export default __webpack_public_path__ + "static/media/img-0508-croatia-full-face.327d19b7.png";